import { useId } from 'react';
import { Switch, Typography } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { Container, Copy, Row, SwitchContainer } from './styled';
export function SwitchField(props) {
    const { name, label, description, disabled } = props;
    const { isSubmitting } = useFormikContext();
    const id = useId();
    const [field, , helpers] = useField(name);
    const { onBlur, value } = field;
    const handleCheckedChange = (checked) => {
        helpers.setValue(checked);
    };
    return (<Container>
      <Row as="label">
        <Copy>
          <Typography $fontSize="medium" $fontWeight="medium">
            {label}
          </Typography>
          <Typography $fontSize="small" $appearance="200" id={id} aria-hidden="true">
            {description}
          </Typography>
        </Copy>
        <SwitchContainer>
          <Switch role="switch" checked={value} disabled={isSubmitting || disabled} aria-labelledby={id} onCheckedChange={handleCheckedChange} onBlur={onBlur}/>
        </SwitchContainer>
      </Row>
    </Container>);
}
